@if (resolving()) {
  <p
    class="gate-resolving body-md text-secondary"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    Checking your access…
  </p>
} @else {
  @switch (blockedBy()) {
    @case ('no_role') {
      <app-no-role />
    }
    @case ('suspended') {
      <app-suspended />
    }
    @default {
      <router-outlet />
    }
  }
}
